import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/** "An opponent was found for your open battle" notification. Subject is the battle's discussion. */
export default class BattleJoinedNotification extends Notification {
  icon() {
    return 'fas fa-user-check';
  }
  href() {
    const discussion = this.attrs.notification.subject();
    return discussion ? app.route.discussion(discussion) : '#';
  }
  content() {
    return app.translator.trans('forumaker-arena.forum.notifications.battle_joined_text');
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/BattleJoinedNotification', BattleJoinedNotification);